function getDomainFromEmail(email: string): string {
  if (email?.includes("@")) {
    const domain = email.split("@")[1];
    return domain;
  }
  return "";
}

export { getDomainFromEmail };
